import { combineReducers, createStore } from 'redux'
import { categoriesReducer } from './category/reducers'
import { selectionsReducer } from './selection/reducers'
import { loadState, saveState } from './localStorage'

const rootReducer = combineReducers({
  categoriesReducer,
  selectionsReducer
})

export type AppState = ReturnType<typeof rootReducer>

const persistedState = loadState()
export const store = createStore(rootReducer, persistedState)

store.subscribe(() => {
  saveState({
    selectionsReducer: store.getState().selectionsReducer
  })
})
